var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningI = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-circle-outline",
    transform: "translate(-3.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M23.5,3.5a20,20,0,0,1,7.784,38.427A20,20,0,0,1,15.716,5.073,19.865,19.865,0,0,1,23.5,3.5Zm0,37.895A17.893,17.893,0,0,0,36.152,10.848a17.893,17.893,0,1,0-25.3,25.3A17.777,17.777,0,0,0,23.5,41.395Z",
    transform: "translate(0 0)",
    fill: "#ff1414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M18.215,10.253a1.62,1.62,0,0,1,1.618,1.692l-.566,12.038a1.053,1.053,0,0,1-2.1,0L16.6,11.947q0-.048,0-.1a1.62,1.62,0,0,1,1.6-1.6Z",
    transform: "translate(5.284 2.725)",
    fill: "#ff1414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M18.567,27a1.973,1.973,0,1,1,1.973-1.973A1.973,1.973,0,0,1,18.567,27Z",
    transform: "translate(4.933 7.541)",
    fill: "#ff1414"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningI);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WarningI.876fb151431f8f161586bef881ad3153.svg";